"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var http_1 = require("@angular/common/http");
var models_1 = require("../models/models");
var AssetsSharedService = /** @class */ (function () {
    function AssetsSharedService() {
    }
    AssetsSharedService.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            if (error instanceof http_1.HttpErrorResponse) {
                var lError = new models_1.Error();
                lError.status = error.status;
                lError.statusText = error.statusText;
                lError.details = error.error;
                return rxjs_1.throwError(lError);
            }
            return rxjs_1.of(result);
        };
    };
    return AssetsSharedService;
}());
exports.AssetsSharedService = AssetsSharedService;
